export default __webpack_public_path__ + "asset/img/temp-index~f8b2ebf3.png";